<template>
  <div>
    <FormulaBanner :title="title" :formulaCode="formulaCode" />
    <div class="index">
      <!-- 表单 -->
      <div>
        <div class="top_nav"><span></span>{{ title }}</div>
        <div class="formBody">
          <!-- 表单 -->
          <MyPatient
            :memberId="memberId"
            :selectValue="selectValue"
            @change="userChange"
          />
          <van-form @submit="onSubmit1"  @failed="onFailed" >
            <van-field
              v-for="(item, index) in listData"
              :key="index"
              v-model="test1[index].value"
              :rules="item.rules"
            >
              <template #input>
                <div class="titles">
                  <div style="display:flex;min-height:20px; flex-direction: column;">
                  <div class="titlesName">
                    {{ item.title }}<i v-if="item.rules">*</i>
                    <van-popover
                        theme="dark"
                        trigger="click"
                        placement="right-start"
                        style="margin-left:5px"
                        v-model="item.show"
                    >
                      <div style="width: 160px;padding: 15px">
                        {{item.detail}}
                      </div>
                      <template #reference>
                        <van-icon name="info" color="#A3A3A3"/>
                      </template>
                    </van-popover>

                  </div>
<!--                  <div style="line-height: 1;color:black;font-size:11px">-->
<!--                    注：{{item.detail}}-->
<!--                  </div>-->
                  </div>
                  <van-radio-group v-model="test1[index].value" style="margin-top:0px">
                   
                    <van-radio
                      v-for="(Columns, index2) in item.columns"
                      :key="index2"
                      :name="Columns"
                      :label="Columns"
                      @click="change(item.title, item.fenzhi[index2], index)"
                      >{{ Columns }}</van-radio
                    >
                  </van-radio-group>
                </div>
              </template>
            </van-field>

            <div v-if="compute === true" style="margin: 16px; display: flex; justify-content: center">
              <van-button
                class="formula-template-button"
                block
                type="info"
                native-type="submit"
                style="width:90px"
                >提交</van-button
              >
            </div>
          </van-form>
        </div>
      </div>
      <CalculationResults
        :countText="countValue"
        :countTextList="[]"
        v-if="show"
      ></CalculationResults>
      <!-- 后台设置的值 -->
      <FormulaExplain :explain-data="tableData.explain"></FormulaExplain>
      <!-- 参考文献 -->
      <FormulaReferences
        :references-data="tableData.references"
      ></FormulaReferences>
    </div>

    <van-popup v-model="showPicker" position="bottom">
      <van-picker
        title="应激指数"
        show-toolbar
        :columns="columns"
        @confirm="onConfirm"
        @cancel="onCancel"
      />
    </van-popup>
  </div>
</template>

<script>
import MyPatient from "@/components/MyPatient.vue";
import FormulaBanner from "@/components/FormulaBanner.vue";
import { Toast } from "vant";
import { getAdmins } from "@/utils/adminDate";
import { setById } from "@/service/base";
import {
  getFormula,
  getFormulaHuiXian,
  postFormula,
} from "@/service/BodyMassIndex_api";
import FormulaExplain from "@/components/template1/FormulaExplain";
import FormulaReferences from "@/components/template1/FormulaReferences";
// import TemplateFiveList from "@/components/Template5/TemplateFiveList";

import CalculationResults from "@/components/CalculationResults";

export default {
  name: "medicalSearch",
  data() {
    return {
      compute:true,
      show:false,
      test1: [],
      countValue: "",
      listSelect: [],
      listData: [
        {
          title: "年龄(岁)",
          columns: ["<40", "40-59", "60-69", "70-74", "75-79", "≥80"],
          fenzhi: [0, 7, 12, 15, 16, 18], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          rules: [{ required: true,  }],
          detail:'为患者最近一次生日时的年龄（岁）',
          show:false,
        },
        {
          title: "HR(次/min)",
          columns: ["70-119", "40-69", "120-159", "≥160", "<40"],
          fenzhi: [0, 2, 4, 7, 11],
          rules: [{ required: true, }],
          detail:"为24小时内最差值（低或高值），如果由心跳骤停（<40）变至心动过速（≥160），指定为<40",
          show:false,
        },
        {
          title: "SBP(mmHg)",
          columns: ["100-199", "≥200", "70-99", "<70"],
          fenzhi: [0, 2, 5, 13], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          rules: [{ required: true, }],
          detail:"与HR相同，如果由<70mmHg变至200mmHg，则为<70",
          show:false,
        },
        {
          title: "T(℃)",
          columns: ["<39", "≥39"],
          fenzhi: [0, 3], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          rules: [{ required: true, }],
           detail:"为最高体温（℃）",
          show:false,
        },
        {
          title: "PaO₂/FiO₂",
          columns: ["≥200", "100-199", "<100","在过去24小时内没有使用机械通气或CPAP"],
          fenzhi: [6, 9, 11, 0], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          detail:"如机械通气或持续肺动脉压监测，则使用最低的比值",
          show:false,
        },
        {
          title: "尿量(L/d)",
          columns: ["≥1.0", "0.50-0.999", "<0.5"],
          fenzhi: [0, 4, 11], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          rules: [{ required: true, }],
           detail:"如患者住院24小时，按下式计算：1L/8h=3L/d",
          show:false,
        },
        {
          title: "血BUN(mmol/L)",
          columns: ["<10.5", "10.5-31.0", "≥32.0"],
          fenzhi: [0, 6, 10], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          rules: [{ required: true, }],
          detail:"为最高值",
          show:false,
        },
        {
          title: "WBC(x10^9/L)",
          columns: ["1.0-19.9", "≥20.0", "<1.0"],
          fenzhi: [0, 3, 12], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          rules: [{ required: true, }],
          detail:"为最差值（高或低值）",
          show: false,
        },
        {
          title: "血钾浓度(mmol/L)",
          columns: ["3.0-4.9", "<3或≥5"],
          fenzhi: [0, 3], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          rules: [{ required: true,  }],
          detail:"为最差值（高或低值）",
          show:false,
        },
        {
          title: "血钠浓度(mmol/L)",
          columns: ["125-144", "≥145", "<125"],
          fenzhi: [0, 1, 5], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          rules: [{ required: true, }],
          detail:"为最差值（高或低值）",
          show:false,
        },
        {
          title: "血HCO₃⁻浓度(mmol/L)",
          columns: ["≥20", "15-19", "<15"],
          fenzhi: [0, 3, 6], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          rules: [{ required: true,  }],
          detail:"为最低值",
          show:false,
        },
        {
          title: "血胆红素浓度(μmol/L)",
          columns: ["<68.4", "68.4-102.5", "≥102.6"],
          fenzhi: [0, 4, 9], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          rules: [{ required: true,  }],
            detail:"为最高值",
          show:false,
        },
        {
          title: "GCS评分",
          columns: ["14-15", "11-13", "9-10", "6-8", "<6"],
          fenzhi: [0, 5, 7, 13, 26], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          rules: [{ required: true,  }],
          detail:"为最低值，如患者使用了镇静药，则记录镇静前估计的GCS",
          show:false,
        },
        {
          title: "慢性疾病",
          columns: ["转移癌", "血液恶性肿瘤", "AIDS","无"],
          fenzhi: [9, 10, 17, 0], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          detail:"转移癌：指手术、CT或任何其他方法证实的转移癌；血液恶性肿瘤：指淋巴癌、急性白血病或多发性骨髓癌；AIDS:指HIV阳性伴下列临床并发症者：卡氏肺囊虫肺炎，卡波氏肉瘤，淋巴瘤、结核或血液中毒性（toxoplasma）感染",
          rules: [{ required: true, }],
          show:false,
        },
        {
          title: "住ICU类型",
          columns: ["择期手术", "内科患者", "急诊手术"],
          fenzhi: [0, 6, 8], //分值顺序必须和选项顺序保持一致！！！！！！！！！！！！！！！
          rules: [{ required: true,  }],
        detail:"拟在24小时内进行手术者为急诊手术；至少在24小时以后进行手术者为择期手术；住ICU1周内不进行手术者为内科患者",
          show:false,
        },
      ],
      formulaCode: "",
      shengao: "",
      yingjizhishu: "",
      title: "",
      memberId: "1111",
      selectValue: "",
      username: "",
      value: "",
      showPopover: false,
      showPicker: false,
      columns: ["", "", "", ""],
      nianling: "",
      xingbie: null,
      tableData: {},
      countText: "",
      patientId: null,
      result: null,
      yingjizhishuzhi: "",
      tizhong: "",
      xueqingnanongdu: "",
      fenzhiList: [],
    };
  },
  components: {
    FormulaBanner,
    MyPatient,
    FormulaExplain,
    FormulaReferences,
    // TemplateFiveList,
    CalculationResults,
  },
  async created() {
    await this.start();
    await this.test();
    await this.getTableData();
  },

  methods: {
    start() {
      this.listData.forEach((item) => {
        this.test1.push({
          title: item.title,
          value: "",
        });
        
        this.fenzhiList.push({
          fenzhi: 0,
        });
      });
    },
    change(title, fenzhi, index) {
      this.show=false
      this.fenzhiList.forEach((item, index1) => {
        if (index == index1) {
          item.fenzhi = fenzhi;
        }
      });
    },
    // listChange (result, fenzhi) {
    //   this.listSelect = result //结果数组
    //   this.fenzhiList = fenzhi  //分值数组
    // },
    coumputTetxt() {
      this.show=true
      let fenshu = 0;
      for (let i = 0; i < this.fenzhiList.length; i++) {
        fenshu += Number(this.fenzhiList[i].fenzhi);
      }
      this.result = fenshu; //分数
      this.countValue = `${fenshu}分 ${this.countText}`;
    },
    async test() {
      //像接口头部传用户信息
      let arrays = await getAdmins(
        this.$route.query.memberId,
        this.$route.query.channel
      );
      this.channel = arrays.os;
      this.version = arrays.version;
      this.ip = arrays.ip;
      await setById(arrays);
    },
    async getTableData() {
      const data = {
        channel: this.$router.currentRoute.query.channel,
        code: "FOZUFDSB",
      };
      const res = await getFormula(data.channel, data.code);
      if (res.code === 0) {
        this.tableData = res.data;
        this.formulaCode = res.data.code;
        this.title = res.data.chineseName;
        // console.log(this.formulaCode, this.title);
      }
      if (
        this.$router.currentRoute.query.location === "YXGS_RECORD_LIST" &&
        this.$router.currentRoute.query.logId
      ) {
        // this.compute = false
        const data = {
          id: this.$router.currentRoute.query.logId,
        };
        const res = await getFormulaHuiXian(data);
        if (res.code === 0) {
          this.listSelect = res.data.content.data;
          if (res.data.patientId)
            this.selectValue = {
              id: res.data.patientId,
              name: res.data.patientName,
            };
          //   this.fenzhiList = [res.data.result.value];
          this.result = res.data.result.value;
          this.countText = res.data.result.result;
          this.countValue =
            res.data.result.value + "分" + res.data.result.result;
            this.show=true
          this.test1 = [...this.test1];
         
          res.data.content.data.forEach((item, index) => {
           
            if (item.title == this.test1[index].title) {
              this.test1[index].value = item.value; //用于回显题目和答案的数组
            }
          });
          this.listData.forEach((item, index) => {
            if (item.title == this.test1[index].title) {
           
              this.listData[index].columns.forEach((value, index2) => {
                if (this.test1[index].value == value) {
                 
                  this.fenzhiList[index].fenzhi =
                    this.listData[index].fenzhi[index2];               
                }
              });
            
            }
          });
        }
      }
    },
    onFailed(){
    Toast.fail("请填写完整！");
    },
    async onSubmit1() {
      // if (!this.listSelect.length || this.listSelect.length === 0) {
      //   Toast.fail('请至少选择一项')
      //   return
      // }

      this.coumputTetxt();
      const data = {
        id:
          this.$router.currentRoute.query.location === "YXGS_RECORD_LIST"
            ? this.$router.currentRoute.query.logId
            : null,
        patientId: this.patientId,
        columnCode: this.tableData.columnCode,
        formulaCode: this.tableData.code,
        channel: this.$router.currentRoute.query.channel,
        location: this.$router.currentRoute.query.location,
        content: {
          data: this.test1,
          // xueqingnanongdu: {value: this.xueqingnanongdu, unit: 'mmol/L'},
        },
        result: {
          value: this.result,
          result: this.countText,
          DisplayResults:this.countValue
        },
      };
      const res = await postFormula(data);
      if (res.code === 0) {
        Toast.success("提交成功");
      } else {
        Toast.fail(res.message);
      }
    },
    // onSubmit1(values) {
    //   console.log("submit", values);
    // },

    calculateAge(birthDateString) {
      const today = new Date();
      const birthDate = new Date(birthDateString);
      let age = today.getFullYear() - birthDate.getFullYear();
      // 如果今天的日期还没到生日月份和日期，则年龄减一
      if (
        today.getMonth() < birthDate.getMonth() ||
        (today.getMonth() === birthDate.getMonth() &&
          today.getDate() < birthDate.getDate())
      ) {
        age--;
      }
      return age;
    },
    // 开参考文献链接
    openLink(u) {
      if (!u) {
        return;
      }
      //获取系统版本
      let userAI = navigator.userAgent;
      const isAndroid =
        userAI.indexOf("Android") > -1 || userAI.indexOf("Linux") > -1; //Android终端
      const isIOS = !!userAI.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
      if (isAndroid) {
        // alert('安卓操作系统')
        // 这个是安卓操作系统
        window.open(u);
      }
      if (isIOS) {
        // 这个是ios操作系统
        // alert('ios操作系统')
        window.location.href = u;
      }
    },
    yingjiClick() {
      this.showPicker = true;
    },
    onConfirm(value) {
      this.yingjizhishu = value;
      this.showPicker = false;
    },
    onCancel() {
      this.showPicker = false;
    },
    async onSubmit() {
      this.coumputTetxt();
      const data = {
        id:
          this.$router.currentRoute.query.location === "YXGS_RECORD_LIST"
            ? this.$router.currentRoute.query.logId
            : null,
        patientId: this.patientId,
        columnCode: this.tableData.columnCode,
        formulaCode: this.tableData.code,
        channel: this.$router.currentRoute.query.channel,
        location: this.$router.currentRoute.query.location,
        content: {
          shengao: { value: this.shengao, unit: "cm" },
          tizhong: { value: this.tizhong, unit: "kg" },
          nianling: { value: this.nianling, unit: "岁" },
          xingbie: { value: this.xingbie == 1 ? "男" : "女" },
          // xueqingnanongdu: {value: this.xueqingnanongdu, unit: 'mmol/L'},
        },
        result: {},
      };
      if (this.xingbie == 1) {
        data.result.nanxing = { value: this.result, unit: "kcal" };
      } else {
        data.result.nvxing = { value: this.result, unit: "kcal" };
      }
      const res = await postFormula(data);
      if (res.code === 0) {
        Toast.success("提交成功");
      } else {
        Toast.fail(res.message);
      }
    },
    userChange(data) {
      if (data.birthday && data.birthday !== "") {
        this.nianling = this.calculateAge(data.birthday);
      } else {
        this.nianling = "";
      }
      this.xingbie = data.sex;
      this.patientId = data.id;
      this.selectValue = data;
    },
  },
};
</script>

<style scoped lang="scss">
.index {
  background: #f6f6f6;
  padding: 10px 15px;
  min-height: 100vh;
  .StandardDescription {
    margin-top: 10px;
    .top_nav {
      font-size: 16px;
      color: #333333;
      font-weight: bold;
      display: flex;
      align-items: center;
      justify-content: start;
      margin-bottom: 10px;
      span {
        display: inline-block;
        width: 5px;
        height: 15px;
        background: #259beb;
        margin-right: 5px;
      }
    }
    .StandardDeatil {
      width: 100%;
      padding: 15px 10px;
      //   height: 50px;
      background-color: #fff;
      box-sizing: border-box;
    }
  }
  .top_nav {
    font-size: 16px;
    color: #333333;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: start;
    margin-bottom: 10px;
    span {
      display: inline-block;
      width: 5px;
      height: 15px;
      background: #259beb;
      margin-right: 5px;
    }
  }
  .formBody {
    background-color: #fff;
    padding-bottom: 10px;
    .CalculationResultsBox {
      padding: 0 8px;
      .CalculationResults {
        font-size: 16px;
        color: #333333;
        font-weight: bold;
        display: flex;
        justify-content: center;
        margin-bottom: 10px;
      }
      .CalculationDetail {
        font-size: 15px;
        color: #333333;
        // font-weight: bold;
        display: flex;
        align-items: center;
        justify-content: start;
        margin-bottom: 10px;
        background-color: #f6f6f6;
        // height: 16px;
        span {
          display: inline-block;
          width: 3px;
          height: 24px;
          background: #fe9712;
          margin-right: 5px;
         
        }
      }
    }
  }
  .titles {
    // display:flex;
    // align-items: center;
    // justify-content: space-between;
    width: 100%;
   
    border-bottom: 1px solid #f0f0f0;
    padding: 5px 10px;
    box-sizing: border-box;
    .titlesName {
      font-size: 16px;
      i {
        color: red;
      }
    }
    .information {
      font-size: 16px;
      margin-right: 4px;
      .PleaseSelect {
        color: #b9b9b9;
      }
      .vanCell {
        width: 50px;
        padding: 0;
        height: 100%;
      }
    }
    .vBotton {
      width: 60px;
    }
    .unit {
      height: 50px;
      //   line-height: 50px;
      display: flex;
      align-items: center;
      font-size: 16px;
      width: 20px;
    }
    .vanIcon {
      font-size: 13px;
      color: #a8a8a8;
      font-weight: 650;
    }
  }
}
::v-deep .van-cell {
  padding: 0px 0px;
}
::v-deep .van-field__control {
  //   height: 50px;
  font-size: 16px;
}
::v-deep .van-field__error-message {
  position: absolute;
  top: 30px;
  left: 10px;
}
.StandardDeatil2 {
  width: 100%;
  padding: 15px 10px;
  padding-bottom: 1px;
  //   height: 50px;
  background-color: #fff;
  box-sizing: border-box;
  .references {
    margin-bottom: 15px;
  }
}
::v-deep p {
  padding: 0;
  margin: 0;
}
.Abutton {
}
::v-deep .van-radio-group {
  display: flex;
  color: #9a9a9a;
  flex-wrap: wrap;
  margin-top: 5px;
}
::v-deep .van-radio {
  display: flex;
  margin: 7px 0;
  min-width: 50%;
}
::v-deep .van-field__error-message{
     position: absolute;
     top:18px;
     font-size: 10px; 
    //  left: 110px;
}
</style>
